import React from "react";
import styles from "./DoctorCard.module.css";
const DoctorCard = ({ item, itemValue, onClickHandler, selectedData }) => {
  return (
    <div
      className={styles.doctorCard}
      style={{
        backgroundColor: itemValue === selectedData && "#296997",
        color: itemValue === selectedData && "white",
      }}
      onClick={() => onClickHandler(itemValue)}
    >
      <span style={{marginRight:"5px"}}>Dr. </span>{item}
    </div>
  );
};

export default DoctorCard;
